export default {
  filters: {
    tooltip: {
      remove_filter: 'Quitar Filtro'
    },
    errors: {
      field_required: 'El Identificador es requerido',
      operator_required: 'El Operador es requerido',
      no_empty_field_and_operator: 'No se pueden guardar búsquedas con campos vacíos en Identificador y Operator.',
      saved_record_limit: 'Has alcanzado el límite de {{count}} búsquedas guardadas.',
      record_already_exist:
        'Ya existe una registro guardado con los mismo parametros de búsqueda - con este nombre de: {{name}}',
      saved_record_limit_replace_tip: 'Quiere reemplazar el registro llamado: "{{record}}"" por el nuevo registro?'
    },
    message: {
      filter_cant_be_nameless: 'El nombre del filtro no puede estar vacío',
      load_saved_record: 'Cargar búsqueda',
      edit_record_name: 'Editar nombre de registro',
      record_details: 'Detalles de la búsqueda',
      hide_details: 'Ocultar detalles',
      show_object_record_details: 'Ver objeto de búsqueda',
      hide_object_record_details: 'Ocultar objeto de búsqueda',
      how_to_use_filters: '¿Como usar los filtros?',
      filter_will_delete: 'Este Filtro se borrará de tu registro de búsquedas',
      filter_save_name: 'Nombre del filtro'
    },
    tips: {
      add_filters: 'Agregar Filtros Principales',
      nest_filters: 'Anida Filtros y optimiza la búsqueda',
      save_filters: 'Guarda los filtros actuales con un nombre',
      manage_filters: 'Ver y Administrar Filtros Guardados',
      select_field: 'Identificador',
      field: 'Selecciona un identificador',
      select_operator: 'Selecciona un operador',
      operator: 'Operador'
    },
    fields: {
      client_name_unaccent: 'Nombre de Cliente',
      olt_id: 'OLT',
      host: 'Host',
      subscription_name: 'Nombre',
      subscription_user: 'Usuario',
      subscription_last_name: 'Apellido',
      service_pack_id: 'Pack'
    },
    operators: {
      cont: 'Contiene',
      not_cont: 'No contiene',
      blank: 'Es nulo o está vacío',
      cont_any: 'Contiene cualquiera de',
      cont_all: 'Contiene todos',
      does_not_match: 'No coincide con',
      does_not_match_all: 'No coincide con todos',
      does_not_match_any: 'No coincide con ninguno',
      end: 'Termina con',
      end_all: 'Termina con todos',
      end_any: 'Termina con cualquiera de',
      eq: 'Es igual a',
      eq_any: 'Es igual a cualquiera de',
      gt: 'Mayor que',
      gt_all: 'Mayor que todos',
      gt_any: 'Mayor que cualquiera',
      gteq: 'Mayor o igual que',
      gteq_all: 'Mayor o igual que todos',
      gteq_any: 'Mayor o igual que cualquiera',
      i_cont: 'Contiene (insensible a mayúsculas)',
      i_cont_all: 'Contiene todos (insensible a mayúsculas)',
      i_cont_any: 'Contiene cualquiera de (insensible a mayúsculas)',
      in: 'En',
      lt: 'Menor que',
      lt_all: 'Menor que todos',
      lt_any: 'Menor que cualquiera',
      lteq: 'Menor o igual que',
      lteq_all: 'Menor o igual que todos',
      lteq_any: 'Menor o igual que cualquiera',
      matches: 'Coincide con',
      matches_all: 'Coincide con todos',
      matches_any: 'Coincide con cualquiera',
      not_cont_all: 'No contiene todos',
      not_cont_any: 'No contiene ninguno de',
      not_end: 'No termina con',
      not_end_all: 'No termina con todos',
      not_end_any: 'No termina con ninguno de',
      not_eq: 'No es igual a',
      not_eq_all: 'No es igual a todos',
      not_i_cont: 'No contiene (insensible a mayúsculas)',
      not_i_cont_any: 'No contiene ninguno de (insensible a mayúsculas)',
      not_null: 'Con información',
      not_in: 'No está en',
      not_start: 'No comienza con',
      not_start_all: 'No comienza con todos',
      not_start_any: 'No comienza con ninguno de',
      null: 'Sin información',
      present: 'No es nulo y no está vacío',
      start: 'Comienza con',
      start_all: 'Comienza con todos',
      start_any: 'Comienza con cualquiera de',
      true: 'Es verdadero',
      false: 'Es falso'
    }
  }
};
